
import Vue from "vue";
import Component from "vue-class-component";
import BaseApp from "@/BaseApp.vue";
import Error from "@/shared/notifications/Error.vue";
import Success from "@/shared/notifications/Success.vue";
import PostInscription from "./PostInscription.vue";
import NoCamps from "./NoCamps.vue";
import FastMail from "./FastMail.vue";
import TabRespo from "./tabs/TabRespo.vue";
import TabParts from "./tabs/TabParts.vue";
import TabInfo from "./tabs/TabInfo.vue";
import TabConclu from "./tabs/TabConclu.vue";
import { C } from "./controller";
import { ConclusionInscription } from "./types";
import { ValidEvent } from "@/shared/utils";
import { BTabs } from "bootstrap-vue";

@Component({
  components: {
    BaseApp,
    Error,
    Success,
    PostInscription,
    NoCamps,
    FastMail,
    TabRespo,
    TabParts,
    TabInfo,
    TabConclu
  }
})
export default class AppComplet extends Vue {
  title = "Portail des inscriptions";

  showFastMail = true;

  inscriptionDone = false;
  checkMail = true;
  urlEspacePerso = "";

  tabIndex = 0;

  output = C.notifications;
  C = C; // besoin d'une référence pour la réactivité

  $refs!: {
    tabs: BTabs;
  };

  get inscription() {
    if (C.data == null) return null;
    return C.data.initial_inscription;
  }

  get isClosed() {
    if (C.data == null) return false; // en attendant les données
    return (C.data.camps || []).length == 0;
  }

  async mounted() {
    await C.loadData();
    if (C.data == null) return;

    // initial values
    if ((C.data.initial_inscription.participants || []).length == 0) {
      Vue.set(C.data.initial_inscription, "participants", [C.newParticipant()]);
    }
    this.showFastMail = !C.data.initial_inscription.responsable.mail;
  }

  async validInscription(ev: ValidEvent) {
    ev.spinning = true;
    const data = await C.validInscription();
    ev.spinning = false;
    if (data == undefined) return;
    this.inscriptionDone = true;
    this.checkMail = data.check_mail;
    this.urlEspacePerso = data.url_espace_perso;
  }

  scrollToTopTab() {
    const nav = this.$refs.tabs.$refs.nav as HTMLElement;
    nav.scrollIntoView();
  }
}
